import { WellKnownSymbol } from '../../constants';
import { WellKnownSymbolBase } from './WellKnownSymbolBase';
export class SymbolToPrimitive extends WellKnownSymbolBase {
    constructor() {
        super(...arguments);
        this.symbol = WellKnownSymbol.toPrimitive;
    }
}

//# sourceMappingURL=toPrimitive.js.map
